module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-mypage-sm-36b8dc6b4ec7747016777cef2f3356f9.png";